module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s02-1_s-052d050d6d64a6e0c4be98d01d379b3a.png";